import React from 'react';
import { Box, Typography, TextField, Button, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

export const Abbreviations = ({ value = [], onChange, editMode = false }) => {
  if (editMode) {
    const handleAddAbbreviation = () => {
      onChange('abbreviations', [...value, { abbreviation: '', meaning: '' }]);
    };

    const handleChange = (index, field, fieldValue) => {
      const newAbbrs = [...value];
      newAbbrs[index] = { ...newAbbrs[index], [field]: fieldValue };
      onChange('abbreviations', newAbbrs);
    };

    const handleRemove = (index) => {
      const newAbbrs = value.filter((_, i) => i !== index);
      onChange('abbreviations', newAbbrs);
    };

    return (
      <Box my={2}>
        <Typography variant="h6" gutterBottom>Abbreviations</Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1, mb: 2 }}>
          Common abbreviations can be omitted. Include only special abbreviations used in this pattern.
        </Typography>
        {value.map((abbr, index) => (
          <Box key={index} display="flex" alignItems="center">
            <TextField
              label="Abbreviation"
              value={abbr.abbreviation || ''}
              onChange={(e) => handleChange(index, 'abbreviation', e.target.value)}
              sx={{ mr: 2, width: 150 }}
              size="small"
            />
            <TextField
              label="Meaning"
              value={abbr.meaning || ''}
              onChange={(e) => handleChange(index, 'meaning', e.target.value)}
              fullWidth
              size="small"
            />
            <IconButton 
              color="error" 
              onClick={() => handleRemove(index)}
              sx={{ ml: 1 }}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        ))}
        <Button 
          variant="outlined" 
          startIcon={<AddIcon />} 
          onClick={handleAddAbbreviation}
          sx={{ mt: 1 }}
          size="small"
        >
          Add Abbreviation
        </Button>
      </Box>
    );
  }

  if (!value || value.length === 0) return null;

  return (
    <Box my={2}>
      <Typography variant="h6" gutterBottom>Abbreviations</Typography>
          {value.map((abbr, index) => (
            <div key={index}>
              {abbr.abbreviation}—{abbr.meaning}
            </div>
          ))}
    </Box>
  );
};

export default Abbreviations;
